let lockCount = 0
let originalBodyOverflow = ''

export const lockBodyScroll = (): void => {
    if (typeof document === 'undefined') {
        return
    }

    if (lockCount === 0) {
        originalBodyOverflow = document.body.style.overflow || ''
        document.body.classList.add('has-modal-open')
    }

    lockCount += 1
    document.body.style.overflow = 'hidden'
}

export const unlockBodyScroll = (): void => {
    if (typeof document === 'undefined' || lockCount === 0) {
        return
    }

    lockCount -= 1

    if (lockCount === 0) {
        document.body.style.overflow = originalBodyOverflow
        document.body.classList.remove('has-modal-open')
        originalBodyOverflow = ''
    }
}
